module.exports = __webpack_public_path__ + "img/shuibeng1.85523c38.png";